import { Component, OnInit, Input } from '@angular/core';

import {bemTiposModuleName} from "../shared/data.service";
import {BemTipo} from "../shared/bem-tipos.model";
import {BemTiposNavigationService} from "../shared/bem-tipos-navigation.service";
import {BemTiposApiService} from "../shared/bem-tipos-api.service";
import {UtilService} from "../../../shared/services/util.service";
import {BemTiposService} from "../shared/bem-tipos.service";

@Component({
  selector: 'app-bem-tipos-list',
  template: require('./bem-tipos-list.component.html'),
  styles: [require('./bem-tipos-list.component.css')]
})
export class BemTiposListComponent implements OnInit {
  @Input() categoriaObject: BemTipo = new BemTipo();
  @Input() showDisabled: boolean = true;

  bemTiposModule: any = bemTiposModuleName;
  list: BemTipo[] = [];

  constructor(
    private _bemTipoNavigationService: BemTiposNavigationService,
    private _bemTiposApiService: BemTiposApiService,
    private _bemTiposService: BemTiposService,
    private _utilService: UtilService
  ) { }

  ngOnInit() {
    this.getAll();
  }

  clickNew() {
    this._bemTiposService.setSessionStorageFatherModule(this.categoriaObject);
    this._bemTipoNavigationService.goToNew();
  }

  clickEdit(item: BemTipo) {
    this._bemTiposService.clearSessionStorage();
    this._bemTipoNavigationService.goToEdit(item.id);
  }

  clickDelete(item: BemTipo) {
    var onDelete = (function() {
      this.onDelete(item);
    }.bind(this));

    this._utilService.swalMessageDelete(onDelete);
  }

  private getAll() {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.list = Response;
      }
      this.loading = false;
    }.bind(this));

    this._bemTiposApiService.onGetByCategoria(this.categoriaObject.id, onDone);
  }

  private onDelete(item: any) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        var x: number, lenX: number;
        for (x = 0, lenX = this.list.length; x < lenX; x++) {
          if (this.list[x].id === item.id) {
            this.list[x].ativo = false;
            break;
          }
        }
        this._utilService.swalMessageDeleteSuccess();
      } else {
        this._utilService.swalMessageDeleteError();
      }
    }.bind(this));

    this._bemTiposApiService.onDelete(item.id, onDone);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/bens/bem-tipos/bem-tipos-list/bem-tipos-list.component.ts
 **/